import React from 'react'
import Button from '../../elements/buttons/Button';

function SlideGuia({ id, logocanal, titulo, resena, canal, tiempo, screenshot, screenshotmobile, screenshottablet, link }) {
  return (
    <div className="SlideGuia" key={id}>
      <div className='envivo'>En vivo</div>
      <div className="SlideGuia-caption">
        <div className="SlideGuia-caption-left">
          <figure className="logoCanal"><img src={logocanal} /></figure>
        </div>
        <div className="SlideGuia-caption-middle">
          <div className='envivo in-caption'>En vivo</div>
          <h4>{titulo}</h4>
          <p className="resena">{resena}</p>
          <p>{canal} <div className="tiempo">/ {tiempo}</div> </p>
        </div>
        <div className="SlideGuia-caption-right">
          <Button copy="Ver ahora" className="button-primary button-icon-play" link={link} />
        </div>
      </div>
      <img src={screenshotmobile} className="mobile"  />
      <img src={screenshottablet} className="tablet"  />
      <figure className='img-container'>  
        <img src={screenshot} className="desktop" />
      </figure>
    </div>
  )
}

export default SlideGuia